import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import SearchIcon from '@mui/icons-material/Search';

//Custom cell renderer for Delete column to show an icon instead
export const DeleteIconRenderer = () => {
    return (
        <span>
            <DeleteIcon />
        </span>
    );
};

export const EditIconRenderer = () => {
    return (
        <span>
            <EditIcon />
        </span>
    );
};

export const EditCommentRenderer = (params) => {
    const caption = params.value ? params.value : 'Add Comment';
    return (
        <>
            <span>
                <EditIcon />
            </span>
            <span>{caption}</span>
        </>
    );
};

export const CopyIconRenderer = () => {
    return (
        <span>
            <CopyAllIcon />
        </span>
    );
};

export const ViewIconRenderer = () => {
    return (
        <span>
            <SearchIcon />
        </span>
    );
};
